export class CRMUC {
    id: number;
    idOportunidade: number;
    numero: string;
    tipo: number;
}  